module.exports = __webpack_public_path__ + "static/media/locked.5df1fd22.svg";